<template>
  <Title :text="contactsLabel" />
  <div v-if="phoneNumber" class="contact-line">
    <img src="@/assets/phone.svg" />
    <Paragraph class="contact" :text="phoneNumber" />
  </div>
  <div v-if="email" class="contact-line">
    <img src="@/assets/email.svg" />
    <Paragraph class="contact" :text="email" />
  </div>
  <div v-if="email" class="contact-line">
    <img src="@/assets/linkedin.svg" />
    <Paragraph class="contact" :text="linkedIn" />
  </div>
    <div v-if="email" class="contact-line">
    <img src="@/assets/github.svg " class="github-image" />
    <Paragraph class="contact" :text="github" />
  </div>
  <div v-if="email" class="contact-line">
    <img src="@/assets/pag_web.svg " class="landingPage" />
    <Paragraph class="contact" :text="landingPage" />
  </div>
  
</template>

<script>
import Title from "@/components/Title.vue";
import Paragraph from "@/components/Paragraph.vue";

export default {
  name: "Contacts",

  components: { Title, Paragraph },

  computed: {
    currentLanguage() {
      return this.$store.state.currentLanguage;
    },

    contactsLabel() {
      return this.currentLanguage.resumeLabels.contacts;
    },

    contacts() {
      return this.currentLanguage.data.contacts;
    },

    phoneNumber() {
      return this.contacts.phone;
    },

    email() {
      return this.contacts.email;
    },

    linkedIn() {
      return this.contacts.linkedIn;
    },

    github(){
      return this.contacts.github
    },
    landingPage(){
      return this.contacts.landingPage
    }
  },
};
</script>

<style scoped>
.contact-line {
  display: flex;
  margin: 0 auto;
  align-items: center;
}

.contact {
  padding-left: 1em;
  margin: 0.25em;
}
.github-image {
  width: 22px; /* Ajusta el tamaño según tus necesidades */
  height: 22px;
  margin-left: 2px;
  margin-right: 0px; /* Espacio entre la imagen y el texto */
}
.landingPage {
  width: 35px; /* Ajusta el tamaño según tus necesidades */
  height: 35px;
  margin-left: -4px;
  margin-right: -6px; /* Espacio entre la imagen y el texto */
}

</style>
